/**
 * Walks Konva parent chain to detect whether `node` is under a {@link Konva.Transformer}.
 * Extracted from the floor-plan host for unit testing and slimmer component surface.
 */
export function konvaNodeIsUnderTransformer(node: unknown): boolean {
  let n: any = node;
  while (n) {
    if (typeof n.getClassName === 'function' && n.getClassName() === 'Transformer') {
      return true;
    }
    n = typeof n.getParent === 'function' ? n.getParent() : null;
  }
  return false;
}
